import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchAccountMenu, fetchHeaderAccountMenu } from "./accountMenu.service";
import { AccountMenuCustomer, AccountMenuSection, HeaderAccountMenuData } from "./accountMenu.types";
import { RejectValueType } from "../redux/redux.types";
import { RootState } from "../../store";
import { handleApiError } from "@/app/utils/handleApiError";

export const getAccountMenu = createAsyncThunk<
  { menus: AccountMenuSection[]; customer: AccountMenuCustomer },
  void,
  RejectValueType & { state: RootState }
>(
  "accountMenu/getAccountMenu",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchAccountMenu();
      return { menus: response.data.menus, customer: response.data.customer };
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { accountMenu } = getState();
      if (accountMenu.data) return false;
      if (accountMenu.status === "loading") return false;
      return true;
    },
  },
);

export const getHeaderAccountMenu = createAsyncThunk<
  HeaderAccountMenuData,
  void,
  RejectValueType & { state: RootState }
>(
  "accountMenu/getHeaderAccountMenu",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchHeaderAccountMenu();
      return response.data;
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { accountMenu } = getState();
      if (accountMenu.headerMenuData) return false;
      if (accountMenu.headerMenuStatus === "loading") return false;
      return true;
    },
  },
);
